module.exports = __webpack_public_path__ + "img/7.a3a9dcef.jpg";